import Dexie, { Table } from "dexie"
import { PhraseStyling, ProjectStyling } from "../styling/types"
import { ProjectConfig } from "../config/types"
import { ProjectSections } from "../projects/types"
import { v4 as uuidv4 } from "uuid"
import { FixedPosition } from "../rearrange/types"
import { Replacement } from "../replacements/types"
import { Code, Coding } from "../coding/types"
export interface PhraseSet {
    hash: string
    value: string
}

export interface Embedding {
    text: string
    embedding: number[]
}

export interface Stats {
    lines: number
    words: number
    characters: number
    vocab: number
}

export interface Project {
    id?: number
    uuid: string
    name: string
    description: string
    createdAt: number
    content: string
    stats: Stats
    styling: ProjectStyling
    config: ProjectConfig
    stopWords: string[] | null
    phraseStylings: PhraseStyling[]
    fixedPositions: FixedPosition[]
    replacements: Replacement[]
    codes: Code[]
    codings: Coding[]
}

export interface Similarity {
    phraseOne: string
    phraseTwo: string
    score: number
}

export interface Thumbnail {
    projectId: number
    thumbnail: string
}

export interface ProjectSectionVersion {
    projectUuid: string
    section: keyof ProjectSections
    version: number
    sync?: boolean
}

export class TextAnalyticsPlusDexie extends Dexie {
    embeddings!: Table<Embedding>
    projects!: Table<Project>
    phraseSets!: Table<PhraseSet>
    similarities!: Table<Similarity>
    thumbnails!: Table<Thumbnail>
    projectSectionVersionsV2!: Table<ProjectSectionVersion>

    constructor(sub: string) {
        super(`textAnalyticsPlus_${sub}`)
        this.version(3).stores({
            projects: "id++, name, createdAt",
            embeddings: "text",
            phraseSets: "hash",
            similarities: "id++, [phraseOne+phraseTwo], score",
            thumbnails: "projectId",
            projectSectionVersions: "[projectId+section]",
        })

        this.version(4)
            .stores({
                projects: "++id, &uuid, name, createdAt",
                embeddings: "text",
                phraseSets: "hash",
                similarities: "++id, [phraseOne+phraseTwo], score",
                thumbnails: "projectId",
                projectSectionVersions: null,
                projectSectionVersionsV2: "[projectUuid+section]",
            })
            .upgrade((tx) => {
                console.log("Migrating projects")
                return tx
                    .table("projects")
                    .toCollection()
                    .modify((project) => {
                        console.log("Migrating project", project)
                        project.uuid = project.uuid || uuidv4()
                    })
            })

        this.version(6).stores({
            projectSectionVersions: null,
            projectSectionVersionsV2: "[projectUuid+section], projectUuid",
        })
    }
}
